"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateContainer = exports.Date = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var DateContainer = _styledComponents["default"].div.withConfig({
  displayName: "DateFormatterstyle__DateContainer",
  componentId: "sc-1sp59be-0"
})(["display:flex;align-items:center;svg path{fill:", ";}", ""], function (props) {
  return props.theme.color.base_25;
}, function (props) {
  return props.size == 'sm' && (0, _styledComponents.css)(["svg{width:18px;height:18px;}"]);
});
exports.DateContainer = DateContainer;
var smallSize = (0, _styledComponents.css)(["font-size:", ";letter-spacing:0.18px;"], function (props) {
  return props.theme.typography.fontSize[12];
});
var mediumSize = (0, _styledComponents.css)(["font-size:", ";letter-spacing:0.25px;"], function (props) {
  return props.theme.typography.fontSize[16];
});
var Date = _styledComponents["default"].div.withConfig({
  displayName: "DateFormatterstyle__Date",
  componentId: "sc-1sp59be-1"
})(["", " line-height:1.33;text-transform:uppercase;color:", ";"], function (props) {
  return props.size == 'sm' ? smallSize : mediumSize;
}, function (props) {
  return props.theme.color.status_alert;
});
exports.Date = Date;
//# sourceMappingURL=DateFormatter.style.js.map